import slugify from "slugify";

export const realisations = [
  {
    name: "Clôture",
    dir: "cloture",
    descriptions: /* html */ `
      <p>
        Délimitation de l’espace. Privatisation et sécurisation du jardin tout en gardant cette espace ouvert sur l’extérieur.
      </p>
      <p> 
        Quoi de mieux pour donner du style tout en privatisant et sécurisant votre espace qu’une belle clôture? 
      </p>
      <p>
        L’ aspect barreaudé allie la résistance, le design et la sécurité. 
      </p>
    `,
  },
  {
    name: "Terrasse Bois",
    dir: "terrasses-bois",
    descriptions: /* html */ `
      <p>
        Ici une terrasse en bois themochauffée maintenue par un système de clips invisibles. 
        Découpes aux pieds de la pergola bioclimatique et habillage du nez de terrasse en bois identique.
      </p>
    `,
  },
  {
    name: "Eclairage extérieur",
    dir: "eclairage",
    descriptions: /* html */ `
    <p>
      Mise en place d’un réseau d’éclairage basse tension afin de baliser le chemin et de mettre en ambiance les végétaux environnants.
      <br />
      Dans un premier temps il faut identifier vos besoins et envies. Est-ce un éclairage purement pratique ou cherchons nous à mettre en valeur une pièce maitresse particulière ?
      <br />
      Une fois cette étape passée, identifions les éléments à éclairer ou à baliser Chemin d’accès, bord de terrasse, arbres et/ou arbustes remarquables, élément minéral particulier... Il ne reste plus qu’à adapter le projecteur à la situation et le tour est joué !
    </p>
    
  `,
  },
  {
    name: "Jeux d’eau",
    dir: "jeu-d-eau",
    descriptions: /* html */ `
      <p>
        Ces éléments de mise en mouvement de l’eau peuvent avoir différentes fonctions et utilités. 
      </p>
      <p> 
        L’aspect principal est l’attrait visuel et auditif pour ce gracieux ballet que produit l’eau en s’envolant puis en retombant tout en produisant ce doux bruit de l’eau qui coule... Que c’est apaisant... 
      </p>
      <p>
        Autre aspect plus terre à terre est, que par ce mouvement, l’eau se charge en oxygène. Cela va permettre à la faune de pouvoir s’épanouir et également limiter le développement des algues. 
      </p>
    `,
  },
].map((el) => ({
  ...el,
  slug: slugify(el.name, { lower: true }),
  hero: `/images/realisations/${el.dir}/hero.jpg`,
  otherImages: new Array(3)
    .fill(0)
    .map((_, index) => `/images/realisations/${el.dir}/d${index + 1}.jpg`),
}));
